module.exports = __webpack_public_path__ + "static/media/1.b6ff4b17.jpg";